import React, { memo, useMemo } from "react"
import PropTypes from "prop-types"
import { randomBytes } from "crypto"

const Clients = ({ children, lang = "de" }) => {
  const content = require("../data/process.json")

  const returnIndex = useMemo(() => {
    switch (lang) {
      case "en":
        return 0
      case "zh":
        return 2
      default:
        return 1
    }
  }, [lang])

  const returnContent = useMemo(() => {
    return content.collection[lang].map(val => (
      <p key={randomBytes(6).toString("hex")}>{val}</p>
    ))
  }, [lang])

  return (
    <div className="clients">
      <section>
        <img
          src="/assets/svg/SI_Website_Clients_Logos.svg"
          alt="Senses Integration Clients' Logo"
        />
      </section>
      <section>
        {children}
        <article>{returnContent}</article>
      </section>
    </div>
  )
}

Clients.propTypes = {
  children: PropTypes.node,
  lang: PropTypes.string,
}

export default memo(Clients)
